export default __webpack_public_path__ + "static/Entenda0050-9ac139b61c863eb35ba6405172c24771.jpg";